import React, {useState, useEffect} from "react";
import { Link } from "@StarberryUtils";
import ScrollAnimation from "react-animate-on-scroll";
import { Button, Form, Container, FormControl, Row, InputGroup, Col} from "react-bootstrap";
import "./Explore.scss";
import {isMobile, isMobileTab} from '../../jsutility/index'
import GrayImgD from "../../../images/StaticPage/grayimg-bg-d.jpg";
import GrayImgT from "../../../images/StaticPage/grayimg-bg-t.jpg";
import GrayImgM from "../../../images/StaticPage/grayimg-bg-m.jpg";


const Explore = (props) => {
    const ExploreList = [
        {
            ExploreImgD : GrayImgD,
            ExploreImgT : GrayImgT,
            ExploreImgM : GrayImgM,
            ExploreHeading : "Explore Oxford",
            ExploreContent : "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam id nulla sapien maecenas et diam id est.",
            ExploreListProp:[
                "Oxford Area Guide",
                "Cowley Area Guide",
                "Summertown Area Guide",
                "Jericho Area Guide",
                "Headington Area Guide",
                "Iffley Area Guide",
                "Botley Area Guide",
            ]
        },
        {
            ExploreImgD : GrayImgD,
            ExploreImgT : GrayImgT,
            ExploreImgM : GrayImgM,
            ExploreHeading : "Explore Thame",
            ExploreContent : "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam id nulla sapien maecenas et diam id est.",
            ExploreListProp:[
                "Thame Area Guide",
                "Haddenham Area Guide",
                "Chinnor Area Guide",
                "Princes Risborough Area Guide",
                "Long Crendon Area Guide",
                "Brill Area Guide",
                "Oakley Area Guide",
            ]
        },
    ];

    let [reviewList, setCustomerReview] = useState([]);
    let intialNumberOfReview = 2;

    useEffect(() => {
        if(isMobile()){
            intialNumberOfReview = 1
        }
        else if(isMobileTab()){
            intialNumberOfReview = 2
        }
        },[])

    useEffect(() => {
          setCustomerReview(ExploreList.slice(0, intialNumberOfReview));
        }, []);

    return (
        <React.Fragment>
            <section className="explore-section">
                <Container>
                    <Row>
                        {reviewList.map((item,index)=>(
                            <Col lg={6} xl={6} >
                                <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                                <div className="explore-card">
                                    <div className="explore-card-img-wrapper img-hover-zoom">
                                    <picture>
                                        <source media="(min-width:992px)" srcSet={item.ExploreImgD} />
                                        <source media="(min-width:768px)" srcSet={item.ExploreImgT} />
                                        <img src={item.ExploreImgM} alt="" />
                                    </picture>
                                    </div>
                                    <div className="explore-card-content">
                                    <ScrollAnimation animateOnce={true} animateIn="fadeInDown"><h6>{item.ExploreHeading}</h6></ScrollAnimation>
                                    <ScrollAnimation animateOnce={true} animateIn="fadeInDown"><p>{item.ExploreContent}</p></ScrollAnimation>
                                        <div className="explore-card-list">
                                            <ul>
                                                {
                                                    item.ExploreListProp && item.ExploreListProp.map(list => ( <li><ScrollAnimation animateOnce={true} animateIn="fadeInDown"> {list} </ScrollAnimation></li>))
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                </ScrollAnimation>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    )
}

export default Explore;